import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from 'react-apollo';

import App from './App';

import registerServiceWorker from './registerServiceWorker';
import './index.css';

const defaults = {};
const resolvers = {};
const typeDefs = null;

const isLocalhost = window.location.hostname === 'localhost';
const useProductionDatabase = false;

const client = new ApolloClient({
  uri:
    !useProductionDatabase && isLocalhost
      ? 'http://localhost:3000/graphql'
      : 'https://apricotbook-api.now.sh/graphql',
  connectToDevTools: true,
  request: operation => {
    operation.setContext({
      headers: {
        authorization: localStorage.getItem('token') || null,
      },
    });
  },
  clientState: {
    defaults,
    resolvers,
    typeDefs,
  },
  onError: err => {
    console.log('apollo error: ');
    console.log(err);
  },
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById('root')
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js